import React from "react";
import "./portfolio.css";

import Fade from "react-reveal/Fade";
const Projects = () => {
  return (
    <>
      <div id="project">
        <h1 className="text text-center h1">
          <u>ABOUT PROJECTS</u>
        </h1>
        <div className="container ">
          <div className="row  mx-auto">
            <Fade left>
              <div className=" col-xl-4 col-md-6  my-4  ">
                <div
                  className="card mx-auto"
                  style={{ width: "20rem", height: "28rem" }}
                >
                  <div class="embed-responsive embed-responsive-4by3">
                    <iframe
                      class="embed-responsive-item"
                      src="https://www.youtube.com/embed/OZo_ryRsYM4"
                    ></iframe>
                  </div>

                  <div className="card-body">
                    <h5 className="card-title">FRONTEND MASTER</h5>
                    <p className="card-text">
                      A website basically deals with frontend courses.This is an
                      team project completed in 5 days. We cover all the
                      functionalities.
                    </p>
                    <div className="container d-flex justify-content-between">
                      <button className="btn ">
                        <a href="https://github.com/Susmita549/Frontend_Master">
                          <span>Click Me!!</span>
                          <span>code</span>
                        </a>
                      </button>
                      <button className="btn ">
                        <a href="https://darling-chebakia-d6a79c.netlify.app/">
                          <span>Click Me!!</span>
                          <span>Website</span>
                        </a>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Fade>
            <Fade top>
              <div className="col-xl-4  col-md-6   my-4 ">
                <div
                  className="card mx-auto"
                  style={{ width: "20rem", height: "28rem" }}
                >
                  <div class="embed-responsive embed-responsive-4by3">
                    <iframe
                      class="embed-responsive-item"
                      src="https://www.youtube.com/embed/mqnzs3f0M2Y"
                    ></iframe>
                  </div>
                  <div className="card-body">
                    <h5 className="card-title">INTERN THEORY</h5>
                    <p className="card-text">
                      A website basically deals with internships in different
                      field.This is an team project completed in 5 days.
                    </p>
                    <div className="container d-flex justify-content-between">
                      <button className="btn ">
                        <a href="https://github.com/Susmita549/Intern-Theory">
                          <span>Click Me!!</span>
                          <span>Code</span>
                        </a>
                      </button>
                      <button className="btn ">
                        <a href="https://tranquil-sherbet-8f6bdd.netlify.app/">
                          {" "}
                          <span>Click Me!!</span>
                          <span>Website</span>
                        </a>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Fade>
            <Fade right>
              <div className="col-xl-4 col-md-6 my-4 ">
                <div
                  className="card mx-auto"
                  style={{ width: "20rem", height: "28rem" }}
                >
                  <div class="embed-responsive embed-responsive-4by3">
                    <iframe
                      class="embed-responsive-item"
                      src="https://www.youtube.com/embed/cjMXaotg6tE"
                    ></iframe>
                  </div>
                  <div className="card-body">
                    <h5 className="card-title">MOVIE APP</h5>
                    <p className="card-text">
                      An app which which us to search different types of
                      movies.We can also sort the movies according to the
                      rating.
                    </p>
                    <div className="container d-flex justify-content-between">
                      <button className="btn ">
                        <a href="https://github.com/Susmita549/Movie-App">
                          {" "}
                          <span>Click Me!!</span>
                          <span>Code</span>
                        </a>
                      </button>
                      <button className="btn ">
                        <a href="https://susmita549.github.io/Movie-App/movie.html">
                          <span>Click Me!!</span>
                          <span>Website</span>
                        </a>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Fade>
            <Fade left>
              <div className="col-xl-4 col-md-6  my-4 ">
                <div
                  className="card mx-auto"
                  style={{ width: "20rem", height: "28rem" }}
                >
                  <div class="embed-responsive embed-responsive-4by3">
                    <iframe
                      class="embed-responsive-item"
                      src="https://www.youtube.com/embed/kYzHU0xzFU4"
                    ></iframe>
                  </div>
                  <div className="card-body">
                    <h5 className="card-title">RESTAURENT APP</h5>
                    <p className="card-text">
                      A simple restaurent app made with react js for searching
                      differnt restaurent according to price and payment option.
                    </p>
                    <div className="container d-flex justify-content-between">
                      <button className="btn ">
                        <a href="https://github.com/Susmita549/Restaurent-App">
                          {" "}
                          <span>Click Me!!</span>
                          <span>Code</span>
                        </a>
                      </button>
                      <button className="btn ">
                        <a href="https://verdant-kringle-66fdf4.netlify.app/">
                          {" "}
                          <span>Click Me!!</span>
                          <span>Website</span>
                        </a>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Fade>
            <Fade bottom>
              <div className="col-xl-4 col-md-6   my-4 ">
                <div
                  className="card mx-auto"
                  style={{ width: "20rem", height: "28rem" }}
                >
                  <div class="embed-responsive embed-responsive-4by3">
                    <iframe
                      class="embed-responsive-item"
                      src="https://www.youtube.com/embed/_y5fdmVcH9o"
                    ></iframe>
                  </div>
                  <div className="card-body">
                    <h5 className="card-title">YOUTUBE</h5>
                    <p className="card-text">
                      Clone of youtube with same UI and implement some of the
                      features like searhing and playing video using Javascript
                    </p>
                    <div className="container d-flex justify-content-between">
                      <button className="btn ">
                        <a href="https://github.com/Susmita549/Youtube">
                          <span>Click Me!!</span>
                          <span>Code</span>
                        </a>
                      </button>
                      <button className="btn ">
                        <a href="https://dreamy-brioche-e82b43.netlify.app/">
                          <span>Click Me!!</span>
                          <span>Website</span>
                        </a>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Fade>
            <Fade right>
              <div className="col-xl-4 col-md-6   my-4">
                <div
                  className="card mx-auto"
                  style={{ width: "20rem", height: "28rem" }}
                >
                  <div class="embed-responsive embed-responsive-4by3">
                  <iframe
                    class="embed-responsive-item"
                    src="https://www.youtube.com/embed/6tK2t3SoJBI"
                    
                    ></iframe>
                    </div>
                  <div className="card-body">
                    <h5 className="card-title">TODO APP</h5>
                    <p className="card-text">
                    ‍A simple to-do list which maintain the tasks you need to complete instead of relying on your memory.

DemoGithub.</p>
                    <div className="container d-flex justify-content-between">
                      <button className="btn ">
                        <a href="https://github.com/Susmita549/React-Todo-App">
                          <span>Click Me!!</span>
                          <span>Code</span>
                        </a>
                      </button>
                      <button className="btn ">
                        <a href="https://velvety-banoffee-05be3c.netlify.app/">
                          {" "}
                          <span>Click Me!!</span>
                          <span>Website</span>
                        </a>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Fade>
          </div>
        </div>
      </div>
    </>
  );
};

export default Projects;
